import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

const hhmm = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—");

const LS_KEY = "zapinBannerDismissed";

export const ZapinBanner = () => {
  const { user } = useAuth();
  const [h, setH] = useState(null);
  const [dismissed, setDismissedState] = useState(() => { try { return localStorage.getItem(LS_KEY); } catch { return null; } });
  const setDismissed = (k) => { setDismissedState(k); try { localStorage.setItem(LS_KEY, k); } catch { /* storage unavailable */ } };
  useEffect(() => {
    const load = () => api.zapin.health().then(setH).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (!h || !["warning", "error"].includes(h.state)) return null;
  const key = `${h.state}|${h.reason}`;
  if (dismissed === key) return null;
  const err = h.state === "error";
  return (
    <div data-testid="zapin-banner" data-state={h.state} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 16px", fontSize: 13,
      background: err ? "rgba(255,59,48,0.10)" : "rgba(255,149,0,0.12)", color: err ? "#b3261e" : "#9a5b00", borderBottom: `1px solid ${err ? "rgba(255,59,48,0.25)" : "rgba(255,149,0,0.3)"}` }}>
      <AlertTriangle size={15} />
      <span style={{ fontWeight: 500 }} data-testid="zapin-banner-text">{h.reason}</span>
      <span className="muted" style={{ fontSize: 12 }} data-testid="zapin-banner-last">Last delivery {hhmm(h.lastDeliveryAt)}</span>
      {user?.role === "admin" && <Link to="/settings#zapin" style={{ fontSize: 12, marginLeft: 4 }} data-testid="zapin-banner-link">Open Zapin settings →</Link>}
      <button onClick={() => setDismissed(key)} style={{ marginLeft: "auto", background: "none", border: 0, cursor: "pointer", color: "inherit", display: "flex" }} aria-label="Dismiss" data-testid="zapin-banner-dismiss"><X size={15} /></button>
    </div>
  );
};
